import {
  AccountTransactionListRes,
  BlockTransactionListRes,
  TransactionDetailRes,
  TransactionListRes,
  TransactionStatus,
} from './response'
import { axiosInstance as Send } from '../axiosInstance'

import { responseType } from '../type'
import config from '../../config'
import constants from '../../constants'

export const getTransactionList = async (page: number, take: number): Promise<responseType<TransactionListRes>> => {
  const url = `${constants.prefix}/${constants.versioning}/transaction/list?pageNumber=${page}&pageSize=${take}`
  return Send.get<responseType<TransactionListRes>>(`${config.EXPLORER_BACKEND_URL + url}`).then(
    (response) => response.data,
  )
}

export const getTransactionDetail = async (txHash: string): Promise<responseType<TransactionDetailRes>> => {
  const url = `${constants.prefix}/${constants.versioning}/transaction/${txHash}`
  return Send.get<responseType<TransactionDetailRes>>(`${config.EXPLORER_BACKEND_URL + url}`).then((res) => res.data)
}

export const getAccountTransactionList = async (
  address: string,
  pageNumber: number,
  pageSize: number,
  status?: TransactionStatus,
): Promise<responseType<AccountTransactionListRes>> => {
  const url = `${config.EXPLORER_BACKEND_URL}${constants.prefix}/${
    constants.versioning
  }/transaction/list?fromAddress=${address}&toAddress=${address}&pageNumber=${pageNumber}&pageSize=${pageSize}${
    status !== null ? `&status=${status}` : ''
  }`
  return Send.get(url).then((response) => response.data)
}

export const getBlockTransactionList = async (
  number: string,
  pageNumber: number,
  pageSize: number,
): Promise<responseType<BlockTransactionListRes>> => {
  const url = `${constants.prefix}/${constants.versioning}/transaction/list?blockNumber=${number}&pageNumber=${pageNumber}&pageSize=${pageSize}`

  return Send.get<responseType<BlockTransactionListRes>>(`${config.EXPLORER_BACKEND_URL + url}`).then(
    (response) => response.data,
  )
}
